/**
 * Support Centre — FAQ categories, accordion, sticky email bar.
 */
(function () {
  var FAQ_NAV_MQ = window.matchMedia("(max-width: 1024px)");

  function updateSpFaqNavScroll(scrollWrap) {
    var nav = scrollWrap.querySelector(".sp-faq-category-nav");
    if (!nav) return;

    var maxScroll = nav.scrollWidth - nav.clientWidth;
    var scrollable = maxScroll > 4;

    scrollWrap.classList.toggle("is-scrollable", scrollable);
    scrollWrap.classList.toggle("is-at-start", !scrollable || nav.scrollLeft <= 4);
    scrollWrap.classList.toggle(
      "is-at-end",
      !scrollable || nav.scrollLeft >= maxScroll - 4
    );
  }

  function scrollSpFaqTabIntoView(nav, btn) {
    if (!nav || !btn || !FAQ_NAV_MQ.matches) return;

    var pad = 12;
    var target =
      btn.offsetLeft - (nav.clientWidth - btn.offsetWidth) / 2;
    var max = nav.scrollWidth - nav.clientWidth;
    target = Math.max(0, Math.min(target, max));

    nav.scrollTo({ left: target, behavior: "smooth" });
  }

  function initSpFaqNavScroll(scrollWrap) {
    if (!scrollWrap || scrollWrap.dataset.spFaqNavInit === "1") return;
    scrollWrap.dataset.spFaqNavInit = "1";

    var nav = scrollWrap.querySelector(".sp-faq-category-nav");
    if (!nav) return;

    var pointerDown = false;
    var startX = 0;
    var scrollStart = 0;
    var dragged = false;

    function onScroll() {
      updateSpFaqNavScroll(scrollWrap);
    }

    nav.addEventListener("scroll", onScroll, { passive: true });

    nav.addEventListener("pointerdown", function (e) {
      if (!FAQ_NAV_MQ.matches || e.button !== 0) return;
      pointerDown = true;
      dragged = false;
      startX = e.clientX;
      scrollStart = nav.scrollLeft;
      nav.classList.add("is-dragging");
      if (nav.setPointerCapture) nav.setPointerCapture(e.pointerId);
    });

    nav.addEventListener("pointermove", function (e) {
      if (!pointerDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) dragged = true;
      nav.scrollLeft = scrollStart - dx;
    });

    function endDrag(e) {
      if (!pointerDown) return;
      pointerDown = false;
      nav.classList.remove("is-dragging");
      if (nav.releasePointerCapture) {
        try {
          nav.releasePointerCapture(e.pointerId);
        } catch (err) {
          /* ignore */
        }
      }
      updateSpFaqNavScroll(scrollWrap);
    }

    nav.addEventListener("pointerup", endDrag);
    nav.addEventListener("pointercancel", endDrag);

    nav.addEventListener(
      "click",
      function (e) {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
          dragged = false;
        }
      },
      true
    );

    if (typeof ResizeObserver !== "undefined") {
      var ro = new ResizeObserver(function () {
        updateSpFaqNavScroll(scrollWrap);
      });
      ro.observe(nav);
    }

    window.addEventListener("resize", onScroll, { passive: true });

    if (FAQ_NAV_MQ.addEventListener) {
      FAQ_NAV_MQ.addEventListener("change", onScroll);
    } else if (FAQ_NAV_MQ.addListener) {
      FAQ_NAV_MQ.addListener(onScroll);
    }

    onScroll();

    return nav;
  }

  function initSpFaq(root) {
    if (!root || root.dataset.spFaqInit === "1") return;
    root.dataset.spFaqInit = "1";

    var catBtns = root.querySelectorAll("[data-sp-faq-cat]");
    var panels = root.querySelectorAll("[data-sp-faq-panel]");
    var scrollWrap = root.querySelector("[data-sp-faq-nav-scroll]");
    var nav = scrollWrap ? initSpFaqNavScroll(scrollWrap) : null;

    catBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var handle = btn.getAttribute("data-sp-faq-cat");
        if (!handle) return;
        catBtns.forEach(function (b) {
          b.classList.remove("is-active");
          b.setAttribute("aria-selected", "false");
          b.setAttribute("tabindex", "-1");
        });
        btn.classList.add("is-active");
        btn.setAttribute("aria-selected", "true");
        btn.setAttribute("tabindex", "0");
        panels.forEach(function (panel) {
          var match = panel.getAttribute("data-sp-faq-panel") === handle;
          panel.classList.toggle("is-active", match);
          panel.hidden = !match;
        });
        if (nav) {
          scrollSpFaqTabIntoView(nav, btn);
          if (scrollWrap) updateSpFaqNavScroll(scrollWrap);
        }
      });

      btn.addEventListener("keydown", function (e) {
        var tabs = Array.from(catBtns);
        var idx = tabs.indexOf(btn);
        if (idx < 0) return;

        var nextIdx = -1;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
          nextIdx = (idx + 1) % tabs.length;
        } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          nextIdx = (idx - 1 + tabs.length) % tabs.length;
        } else if (e.key === "Home") {
          nextIdx = 0;
        } else if (e.key === "End") {
          nextIdx = tabs.length - 1;
        } else {
          return;
        }

        e.preventDefault();
        tabs[nextIdx].click();
        tabs[nextIdx].focus();
      });
    });

    var activeBtn = root.querySelector(".sp-fcn-btn.is-active");
    if (activeBtn && nav) {
      requestAnimationFrame(function () {
        scrollSpFaqTabIntoView(nav, activeBtn);
        if (scrollWrap) updateSpFaqNavScroll(scrollWrap);
      });
    }

    root.addEventListener("click", function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      var qBtn = t.closest("[data-sp-faq-q]");
      if (!qBtn || !root.contains(qBtn)) return;
      e.preventDefault();
      var panel = qBtn.closest("[data-sp-faq-panel]");
      if (!panel) return;
      var ans = qBtn.nextElementSibling;
      var open = qBtn.classList.contains("is-open");
      panel.querySelectorAll("[data-sp-faq-q].is-open").forEach(function (q) {
        q.classList.remove("is-open");
        q.setAttribute("aria-expanded", "false");
        var a = q.nextElementSibling;
        if (a && a.classList.contains("sp-faq-a")) {
          a.classList.remove("is-open");
          a.setAttribute("hidden", "");
        }
      });
      if (!open && ans) {
        qBtn.classList.add("is-open");
        qBtn.setAttribute("aria-expanded", "true");
        ans.classList.add("is-open");
        ans.removeAttribute("hidden");
      }
    });
  }

  function initStickyBar() {
    var bar = document.querySelector("[data-sp-sticky-bar]");
    if (!bar) return;
    var threshold = 320;
    function onScroll() {
      bar.classList.toggle("is-visible", window.scrollY > threshold);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function init() {
    document.querySelectorAll("[data-sp-faq]").forEach(initSpFaq);
    initStickyBar();
    document.querySelectorAll("[data-sp-faq-cat-link]").forEach(function (link) {
      link.addEventListener("click", function (e) {
        var handle = link.getAttribute("data-sp-faq-cat-link");
        if (!handle) return;
        var faq = document.getElementById("sp-faq");
        var root = document.querySelector("[data-sp-faq]");
        if (!root) return;
        var btn = root.querySelector('[data-sp-faq-cat="' + handle + '"]');
        if (btn) {
          e.preventDefault();
          btn.click();
          if (faq) {
            setTimeout(function () {
              faq.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 80);
          }
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
